// src/services/api.js

import axios from 'axios';

// 1. Cria uma instância do Axios.
//    CORREÇÃO DEFINITIVA: Usamos a baseURL RELATIVA '/api'.
//    - Localmente: O React usará o "proxy" do package.json para repassar à porta 4001.
//    - No Servidor (Hostinger): Ele fará chamadas relativas que o Apache já sabe tratar.
//    Dessa forma, não precisamos nos preocupar com URLs absolutas no .env do frontend!
const api = axios.create({
  baseURL: '/api',
});

// 2. O Interceptor (Perfeito, mantido exatamente como estava)
//    Esta função será executada ANTES de CADA requisição.
api.interceptors.request.use(
  async (config) => {
    // 3. Busca o token que salvamos no localStorage.
    const token = localStorage.getItem('token');

    // 4. Se o token existir, ele é adicionado ao cabeçalho (header) da requisição.
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // 5. A requisição continua seu caminho.
    return config;
  },
  (error) => {
    // Em caso de erro na configuração da requisição
    return Promise.reject(error);
  }
);

export default api;